import type { WrappedCoin } from "@screener/protocol";
import { cn } from "@screener/uikit/lib/utils";
import { wrappedMark } from "@/lib/labels";

/**
 * Пометка обёрнутой монеты рядом с парой — часть экрана, не UIKit: она
 * сверяется с перечнем приветствия. Текст задаёт `wrappedMark`, здесь только
 * оформление: приглушённый мелкий текст, как соседние вторичные подписи.
 * Монета вне перечня — ничего.
 */
export function WrappedMark({
  base,
  wrapped,
  className,
}: {
  base: string;
  wrapped: readonly WrappedCoin[];
  className?: string;
}) {
  const mark = wrappedMark(base, wrapped);
  if (mark === undefined) {
    return null;
  }
  return (
    <span
      data-slot="wrapped-mark"
      className={cn("text-[11px] font-normal text-muted-foreground", className)}
    >
      {mark}
    </span>
  );
}
